export enum SupervisorReportsType {
  SET_AVGWAIT = "SET_AVGWAIT",
  SET_TIME_INTERVAL = "SET_TIME_INTERVAL",
  SET_PERFREPORT = "SET_PERFREPORT",
  SET_PERFREPORTTABLE = "SET_PERFREPORTTABLE",
  SET_SLAREPORT = "SET_SLAREPORT",
  SETREPORTLOADER = "SETREPORTLOADER",
  SET_FILTERS = "SET_FILTERS",
  SET_CALLBACKFILTERS = "SET_CALLBACKFILTERS",
  SET_CALLBACKSUMMARYREPORT = "SET_CALLBACKSUMMARYREPORT",
  SET_ALLAGENTS = "SET_ALLAGENTS",
  SET_AGENTCALLSUMMARYREPORT = "SET_AGENTCALLSUMMARYREPORT",
  SET_AGENTPERFREPORT = "SET_AGENTPERFREPORT",
  SET_AGENTMISSEDCALLREPORT = "SET_AGENTMISSEDCALLREPORT",
  SET_AGENTCALLSUMMARYTYPES = "SET_AGENTCALLSUMMARYTYPES",
  SET_AGENTPERFREPORTTYPES = "SET_AGENTPERFREPORTTYPES",
  SET_AGENTMISSEDRATE = "SET_AGENTMISSEDRATE",
  SET_CLEARSTATE = "SET_CLEARSTATE"


}
